import update from 'immutability-helper';
import ActionTypes from 'constants/ActionTypes';

const initialState = {
    fetching: true,
    fetchingIds: [],
    error: {
        status: null,
        type: null,
    },
    data: {},
};

const searchIntentReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.DATA_SEARCH_INTENT_FETCHING: {
            return update(state, {
                fetching: { $set: true },
                fetchingIds: { $set: action?.payload?.keywordsIds || [] },
            });
        }
        case ActionTypes.DATA_SEARCH_INTENT_RECEIVED: {
            const newData = {
                ...state.data.data,
                ...action.payload?.data
            };
            return update(state, {
                fetching: { $set: false },
                fetchingIds: { $set: [] },
                data: { data: { $set: newData } },
                error: { $set: initialState.error },
            });
        }
        case ActionTypes.DATA_SINGLE_SEARCH_INTENT_RECEIVED: {
            const newData = {
                ...state.data.data,
                ...action.payload
            };
            return update(state, {
                data: { data: { $set: newData } },
                error: { $set: initialState.error },
            });
        }
        case ActionTypes.DATA_SEARCH_INTENT_ERROR: {
            return update(state, {
                data: { $set: initialState.data },
                fetchingIds: { $set: [] },
                fetching: { $set: false },
                error: {
                    status: { $set: action.payload.status },
                    type: { $set: action.payload.type },
                },
            });
        }
        default: {
            return state;
        }
    }
};

export default searchIntentReducer;